import { lazy } from "react";

import PublicLayout from "../layouts/templates/PublicLayout/PublicLayout";
import AboutUs from "../pages/About/About";
import Contact from "../pages/ContactUs/Contact";
import Factories from "../pages/Partners/Factories/Factories";
import Stores from "../pages/Partners/Stores/Stores";
import Wholesalers from "../pages/Partners/wholesalers/wholesalers";
import Blog_List from "../pages/Blogs/BlogList/Blog_List";
import Blog_Details from "../pages/Blogs/BlogDetails/Blog_Details";
import Thankyou from "../pages/Thankyou/Thankyou";
import AuthLayout from "../layouts/templates/AuthLayout/AuthLayout";

// Lazy Imports
const FactoryDashboard = lazy(() => import("../pages/@factory/FactoryDashboard/FactoryDashboard"));
const CertifierDashboard = lazy(() => import("../pages/@Certifier/CertifierDashboard/CertifierDashboard"));
const WholesalerDashboard = lazy(() => import("../pages/@Wholesaler/WholesalerDashboard/WholesalerDashboard"));
const CustomerDashboard = lazy(() => import("../pages/CustomerDashboard/CustomerDashboard"));
const View_Reports = lazy(() => import("../pages/View_Reports/View_Reports"));
const Submit_New_Products = lazy(() => import("../pages/@factory/Submit_New_Products/Submit_New_Products"));
const View_Assigned_Schedules = lazy(() => import("../pages/View_Assigned_Schedules/View_Assigned_Schedules"));
const Check_In_product_QR_codes = lazy(() => import("../pages/@Certifier/Check_In_product_QR_codes/Check_In_product_QR_codes"));
const Scan_Received_Products = lazy(() => import("../pages/@Wholesaler/Scan_Received_Products/Scan_Received_Products"));
const Generate_Reports = lazy(() => import("../pages/@Wholesaler/Generate_Reports/Generate_Reports"));
const ViewProductsPage = lazy(() => import("../pages/@User/ViewProductsPage"));
const CertificationManagementPage = lazy(() => import("../pages/@Admin/@CERTIFICATIONS/CertificationManagementPage"));
const CertificationStatisticsPage = lazy(() => import("../pages/@Admin/@CERTIFICATIONS/CertificationStatisticsPage"));
const ActivityLogsPage = lazy(() => import("../pages/@Admin/@USERS/ActivityLogsPage"));
const Product_History = lazy(() => import("../pages/Product_History/Product_History"));
const Manage_Labels = lazy(() => import("../pages/Manage_Labels/Manage_Labels"));
const Approve_labels = lazy(() => import("../pages/@Certifier/Approve_labels/Approve_labels"));
const Statistiques = lazy(() => import("../pages/@Admin/Statistiques/Statistiques"));
const ManageStoresPage = lazy(() => import("../pages/@Admin/@STORES/ManageStoresPage"));
const View_Scan_Logs = lazy(() => import("../pages/@Admin/View_Scan_Logs/View_Scan_Logs"));
const ViewStoresPage = lazy(() => import("../pages/@User/ViewStoresPage"));
const My_stores = lazy(() => import("../pages/@factory/My_stores/My_stores"));
const Manage_Reviews = lazy(() => import("../pages/@Admin/@REVIEWS/Manage_Reviews/Manage_Reviews"));
const Manage_Reports = lazy(() => import("../pages/@Admin/@REPORTS/Manage_Reports/Manage_Reports"));
const Stores_products_Reports = lazy(() => import("../pages/@factory/Stores_products_Reports/Stores_products_Reports"));
const Modify_store = lazy(() => import("../pages/@factory/Modify_store/Modify_store"));
const ProductCertificationPage = lazy(() => import("../pages/@Certifier/ProductCertificationPage"));
const ShiftManagementPage = lazy(() => import("../pages/@Admin/@SHIFTS/ShiftManagementPage"));
const MyShiftsPage = lazy(() => import("../pages/@Certifier/MyShiftsPage"));
const Product_Request_Interface = lazy(() => import("../pages/@Wholesaler/Product_Request_Interface/Product_Request_Interface"));
const Wholesaler_Labels = lazy(() => import("../pages/@Wholesaler/Wholesaler_Labels/Wholesaler_Labels"));
const Wholesaler_Certificates = lazy(() => import("../pages/@Wholesaler/Wholesaler_Certificates/Wholesaler_Certificates"));
const MyExpense = lazy(() => import("../pages/MyExpense/MyExpense"));
const Approve_Expense = lazy(() => import("../pages/@Admin/@EXPENSES/Approve_Expense/Approve_Expense"));
const Wholesaler_Stores_Connected = lazy(() => import("../pages/@Wholesaler/Wholesaler_Stores_Connected/Wholesaler_Stores_Connected"));
const Manage_Wholesaler_Stores_Connected = lazy(() => import("../pages/@Admin/@STORES/Manage_Wholesaler_Stores_Connected/Manage_Wholesaler_Stores_Connected"));
const Analytics_Wholesaler_Activity = lazy(() => import("../pages/@Wholesaler/Analytics_Wholesaler_Activity/Analytics_Wholesaler_Activity"));
const Offline_Sync_Logs = lazy(() => import("../pages/@Admin/Offline_Sync_Logs/Offline_Sync_Logs"));
const Reporting_Analytics = lazy(() => import("../pages/Reporting_Analytics/Reporting_Analytics"));
const Admin_Settings = lazy(() => import("../pages/@Admin/Admin_Settings/Admin_Settings"));
const MaintenancePage = lazy(() => import("../pages/MaintenancePage/MaintenancePage"));
const Product_Traceability_View = lazy(() => import("../pages/@Admin/Product_Traceability_View/Product_Traceability_View"));
const LabelAdministration = lazy(() => import("../pages/label_administration/label_administration"));
const Staff_Shift_Oversight = lazy(() => import("../pages/Staff_Shift_Oversight/Staff_Shift_Oversight"));
const Store_Wholesaler_Oversight = lazy(() => import("../pages/Store_Wholesaler_Oversight/Store_Wholesaler_Oversight"));
const Manage_Chats = lazy(() => import("../pages/@Admin/Manage_Chats/Manage_Chats"));
const Features_Management = lazy(() => import("../pages/@Admin/Features_Management/Features_Management"));
const SupervisorDashboardPage = lazy(() => import("../pages/@CertifierBodyAdmin/SupervisorDashboardPage"));
const Manage_Reassignment_Label = lazy(() => import("../pages/Manage_Reassignment_Label/Manage_Reassignment_Label"));
const CertificationTransparencyPage = lazy(() => import("../pages/@Admin/@CERTIFICATIONS/CertificationTransparencyPage"));
const Product_Quality = lazy(() => import("../pages/@Admin/Product_Quality/Product_Quality"));
const Manage_my_store = lazy(() => import("../pages/@Store/Manage_my_store/Manage_my_store"));
const CreateUserPage = lazy(() => import("../pages/@Admin/@USERS/CreateUserPage"));
const Profile_Informations = lazy(() => import("../pages/Profile_Informations/Profile_Informations"));
const PasswordRecovery = lazy(() => import("../components/PasswordRecovery/PasswordRecovery"));
const Create_Article = lazy(() => import("../pages/Create_Article/Create_Article"));
const StoreDashboard = lazy(() => import("../pages/StoreDashboard/StoreDashboard"));
const ShiftDetailsPage = lazy(() => import("../pages/@Admin/@SHIFTS/ShiftDetailsPage"));
const Find_Stores = lazy(() => import("../pages/Find_Stores/Find_Stores"));
const Certification_Feed = lazy(() => import("../pages/Certification_Feed/Certification_Feed"));
const Advertisement_Management = lazy(() => import("../pages/@Admin/Advertisement_Management/Advertisement_Management"));
const Home = lazy(() => import("../pages/Home/Home"));
const Login = lazy(() => import("../pages/Login/Login"));
const Signup = lazy(() => import("../pages/Signup/Signup"));
const NotFound = lazy(() => import("../pages/Error/404/404"));
const Admindashboard = lazy(() => import("../pages/@Admin/Admin-dashboard/Admindashboard"));
const Allergen_Management = lazy(() => import("../pages/@Admin/Allergen_Management/Allergen_Management"));
const Charity_Partner_Management = lazy(() => import("../pages/@Admin/@PARTNERS/Charity_Partner_Management/Charity_Partner_Management"));
const Mileage_Expenses = lazy(() => import("../pages/@Admin/@EXPENSES/Mileage_Expenses/Mileage_Expenses"));
const Document_Management = lazy(() => import("../pages/@Admin/Document_Management/Document_Management"));
const ManageUserListPage = lazy(() => import("../pages/@Admin/@USERS/ManageUserListPage"));
const Super_Admin_dashboard = lazy(() => import("../pages/@SuperAdmin/Super_Admin_dashboard/Super_Admin_dashboard"));
const ProductManagementPage = lazy(() => import("../pages/ProductManagementPage"));

// ================== Route Groups ==================

export const ROUTES_SUPER_ADMIN = [
  // Dashboard
  { path: "/Super_Admin_dashboard", element: <Super_Admin_dashboard />, label: "Super Admin dashboard" },
  { path: "/Submit_New_Products", element: <Submit_New_Products />, label: "Submit New Products" },
  { path: "/Edit_Products", element: <ProductManagementPage />, label: "Edit Products" },
  
  // User Management
  { path: "/ActivityLogsPage", element: <ActivityLogsPage />, label: "Activity Logs" },
  { path: "/CreateUserPage", element: <CreateUserPage />, label: "Create User" },
  { path: "/ManageUserListPage", element: <ManageUserListPage />, label: "Manage Users" },
  
  // Store Management
  { path: "/ManageStoresPage", element: <ManageStoresPage />, label: "Manage Stores" },
  { path: "/Manage_Wholesaler_Stores_Connected", element: <Manage_Wholesaler_Stores_Connected />, label: "Manage Wholesaler Stores Connected" },
  { path: "/ViewStoresPage", element: <ViewStoresPage />, label: "View Stores" },
  
  // Product Management
  { path: "/ViewProductsPage", element: <ViewProductsPage />, label: "View Products" },
  { path: "/Product_Quality", element: <Product_Quality />, label: "Product Quality" },
  { path: "/Product_Traceability_View", element: <Product_Traceability_View />, label: "Product Traceability" },
  
  // Certification Management
  { path: "/CertificationManagementPage", element: <CertificationManagementPage />, label: "Approve Certification" },
  { path: "/CertificationStatisticsPage", element: <CertificationStatisticsPage />, label: "Certification Statistics" },
  { path: "/CertificationTransparencyPage", element: <CertificationTransparencyPage />, label: "Certification Transparency" },
  
  // Label Management
  /*  ---  */{ path: "/Label_administration", element: <LabelAdministration />, label: "Label Administration" },
  { path: "/Manage_Reassignment_Label", element: <Manage_Reassignment_Label />, label: "Manage Reassignment Label" },
  
  // Shift Management
  { path: "/ShiftManagementPage", element: <ShiftManagementPage />, label: "Planning Shifts Administration" },
  { path: "/ShiftDetailsPage", element: <ShiftDetailsPage />, label: "Shift Details" },
  { path: "/Staff_Shift_Oversight", element: <Staff_Shift_Oversight />, label: "Staff Shift Oversight" },
  
  // Expense Management
  { path: "/Approve_Expense", element: <Approve_Expense />, label: "Approve Expense" },
  { path: "/Mileage_Expenses", element: <Mileage_Expenses />, label: "Mileage Expenses" },
  
  // Analytics & Reports
  { path: "/View_Reports", element: <View_Reports />, label: "View Reports" },
  { path: "/Reporting_Analytics", element: <Reporting_Analytics />, label: "Reporting Analytics" },
  { path: "/Statistiques", element: <Statistiques />, label: "Statistics" },
  { path: "/View_Scan_Logs", element: <View_Scan_Logs />, label: "View Scan Logs" },
  { path: "/Offline_Sync_Logs", element: <Offline_Sync_Logs />, label: "Offline Sync Logs" },
  { path: "/Store_Wholesaler_Oversight", element: <Store_Wholesaler_Oversight />, label: "Store Wholesaler Oversight" },
  
  // Content Management
  { path: "/Create_Article", element: <Create_Article />, label: "Create Article" },
  { path: "/Advertisement_Management", element: <Advertisement_Management />, label: "Advertisement Management" },
  { path: "/Manage_Reviews", element: <Manage_Reviews />, label: "Manage Reviews" },
  
  // System Management
  { path: "/Admin_Settings", element: <Admin_Settings />, label: "Admin Settings" },
  { path: "/Features_Management", element: <Features_Management />, label: "Features Management" },
  { path: "/Manage_Chats", element: <Manage_Chats />, label: "Manage Chats" },
  { path: "/Manage_Reports", element: <Manage_Reports />, label: "Manage Reports" },
  { path: "/Allergen_Management", element: <Allergen_Management />, label: "Allergen Management" },
  { path: "/Charity_Partner_Management", element: <Charity_Partner_Management />, label: "Charity Partner Management" },
  { path: "/Document_Management", element: <Document_Management />, label: "Document Management" },
  
  // Profile
  { path: "/Profile_Informations", element: <Profile_Informations />, label: "Profile Information" },
];

export const ROUTES_ADMIN = [
  // Dashboard
  { path: "/Admindashboard", element: <Admindashboard />, label: "Dashboard" },
  
  // User Management
  { path: "/ActivityLogsPage", element: <ActivityLogsPage />, label: "Activity Logs" },
  { path: "/CreateUserPage", element: <CreateUserPage />, label: "Create User" },
  { path: "/ManageUserListPage", element: <ManageUserListPage />, label: "Manage Users" },
  
  // Store Management
  { path: "/ManageStoresPage", element: <ManageStoresPage />, label: "Manage Stores" },
  { path: "/Manage_Wholesaler_Stores_Connected", element: <Manage_Wholesaler_Stores_Connected />, label: "Manage Wholesaler Stores Connected" },
  { path: "/ViewStoresPage", element: <ViewStoresPage />, label: "View Stores" },
  
  // Product Management
  { path: "/ViewProductsPage", element: <ViewProductsPage />, label: "View Products" },
  { path: "/Product_Quality", element: <Product_Quality />, label: "Product Quality" },
  { path: "/Product_Traceability_View", element: <Product_Traceability_View />, label: "Product Traceability" },
  
  // Certification Management
  { path: "/CertificationManagementPage", element: <CertificationManagementPage />, label: "Approve Certification" },
  { path: "/CertificationStatisticsPage", element: <CertificationStatisticsPage />, label: "Certification Statistics" },
  { path: "/CertificationTransparencyPage", element: <CertificationTransparencyPage />, label: "Certification Transparency" },
  
  // Label Management
  { path: "/Label_administration", element: <LabelAdministration />, label: "Label Administration" },
  { path: "/Manage_Reassignment_Label", element: <Manage_Reassignment_Label />, label: "Manage Reassignment Label" },
  
  // Shift Management
  { path: "/ShiftManagementPage", element: <ShiftManagementPage />, label: "Planning Shifts Administration" },
  { path: "/ShiftDetailsPage", element: <ShiftDetailsPage />, label: "Shift Details" },
  { path: "/Staff_Shift_Oversight", element: <Staff_Shift_Oversight />, label: "Staff Shift Oversight" },
  
  // Expense Management
  { path: "/Approve_Expense", element: <Approve_Expense />, label: "Approve Expense" },
  { path: "/Mileage_Expenses", element: <Mileage_Expenses />, label: "Mileage Expenses" },
  
  // Analytics & Reports
  { path: "/View_Reports", element: <View_Reports />, label: "View Reports" },
  { path: "/Reporting_Analytics", element: <Reporting_Analytics />, label: "Reporting Analytics" },
  { path: "/Statistiques", element: <Statistiques />, label: "Statistics" },
  { path: "/View_Scan_Logs", element: <View_Scan_Logs />, label: "View Scan Logs" },
  { path: "/Offline_Sync_Logs", element: <Offline_Sync_Logs />, label: "Offline Sync Logs" },
  { path: "/Store_Wholesaler_Oversight", element: <Store_Wholesaler_Oversight />, label: "Store Wholesaler Oversight" },
  
  // Content Management
  { path: "/Create_Article", element: <Create_Article />, label: "Create Article" },
  { path: "/Advertisement_Management", element: <Advertisement_Management />, label: "Advertisement Management" },
  { path: "/Manage_Reviews", element: <Manage_Reviews />, label: "Manage Reviews" },
  
  // System Management
  { path: "/Admin_Settings", element: <Admin_Settings />, label: "Admin Settings" },
  { path: "/Features_Management", element: <Features_Management />, label: "Features Management" },
  { path: "/Manage_Chats", element: <Manage_Chats />, label: "Manage Chats" },
  { path: "/Manage_Reports", element: <Manage_Reports />, label: "Manage Reports" },
  { path: "/Allergen_Management", element: <Allergen_Management />, label: "Allergen Management" },
  { path: "/Charity_Partner_Management", element: <Charity_Partner_Management />, label: "Charity Partner Management" },
  { path: "/Document_Management", element: <Document_Management />, label: "Document Management" },
  
  // Profile
  { path: "/Profile_Informations", element: <Profile_Informations />, label: "Profile Information" },
];

export const ROUTES_CERTIFIER_BODY_ADMIN = [
  // Dashboard
  { path: "/certifier-dashboard", element: <CertifierDashboard />, label: "Dashboard" },
  
  // Supervision
  { path: "/SupervisorDashboardPage", element: <SupervisorDashboardPage />, label: "Supervisor Module" },
  
  // Certification Management
  { path: "/CertificationManagementPage", element: <CertificationManagementPage />, label: "Approve Certification" },
  { path: "/CertificationStatisticsPage", element: <CertificationStatisticsPage />, label: "Certification Statistics" },
  { path: "/CertificationTransparencyPage", element: <CertificationTransparencyPage />, label: "Certification Transparency" },
  
  // Label Management
  { path: "/Label_administration", element: <LabelAdministration />, label: "Label Administration" },
  { path: "/Manage_Reassignment_Label", element: <Manage_Reassignment_Label />, label: "Manage Reassignment Label" },
  
  // Shift Management
  { path: "/ShiftManagementPage", element: <ShiftManagementPage />, label: "Planning Shifts Administration" },
  { path: "/ShiftDetailsPage", element: <ShiftDetailsPage />, label: "Shift Details" },
  { path: "/Staff_Shift_Oversight", element: <Staff_Shift_Oversight />, label: "Staff Shift Oversight" },
  
  // Profile
  { path: "/Profile_Informations", element: <Profile_Informations />, label: "Profile Information" },
];

export const ROUTES_CERTIFIER = [
  // Dashboard
  { path: "/certifier-dashboard", element: <CertifierDashboard />, label: "Dashboard" },
  
  // Product Certification
  { path: "/Check_In_product_QR_codes", element: <Check_In_product_QR_codes />, label: "Check-in Product QR Codes" },
  { path: "/ProductCertificationPage", element: <ProductCertificationPage />, label: "Product Certification" },
  { path: "/ViewProductsPage", element: <ViewProductsPage />, label: "View Products" },
  
  // Label Management
  { path: "/Approve_labels", element: <Approve_labels />, label: "Approve Labels" },
  
  // Shift Management
  { path: "/MyShiftsPage", element: <MyShiftsPage />, label: "My Shifts" },
  
  // Expense Management
  { path: "/MyExpense", element: <MyExpense />, label: "My Expense" },
  
  // Profile
  { path: "/Profile_Informations", element: <Profile_Informations />, label: "Profile Information" },
];

export const ROUTES_FACTORY = [
  // Dashboard
  { path: "/factory-dashboard", element: <FactoryDashboard />, label: "Dashboard" },
  
  // Product Management
  { path: "/Submit_New_Products", element: <Submit_New_Products />, label: "Submit New Products" },
  { path: "/Edit_Products", element: <ProductManagementPage />, label: "Edit Products" },
  { path: "/Manage_Labels", element: <Manage_Labels />, label: "Manage Labels" },
  
  // Store Management
  /*
  { path: "/My_stores", element: <My_stores />, label: "My Stores" },
  { path: "/Modify_store", element: <Modify_store />, label: "Modify Store" },
  */

  //label
  { path: "/Manage_Labels", element: <Manage_Labels />, label: "Manage Labels" },
 
  // Analytics & Reports
  { path: "/Stores_products_Reports", element: <Stores_products_Reports />, label: "Store Products Reports" },
  { path: "/Reporting_Analytics", element: <Reporting_Analytics />, label: "Reporting Analytics" },
  
  // Expense Management
  { path: "/MyExpense", element: <MyExpense />, label: "My Expense" },
  
  // Profile
  { path: "/Profile_Informations", element: <Profile_Informations />, label: "Profile Information" },
];

export const ROUTES_WHOLESALER = [
  // Dashboard
  { path: "/wholesaler-dashboard", element: <WholesalerDashboard />, label: "Dashboard" },
  
  // Product Management
  { path: "/Scan_Received_Products", element: <Scan_Received_Products />, label: "Scan Received Products" },
  { path: "/Product_Request_Interface", element: <Product_Request_Interface />, label: "Product Request Interface" },
  { path: "/Manage_Labels", element: <Manage_Labels />, label: "Manage Labels" },
  
  // Store Management
  { path: "/Wholesaler_Stores_Connected", element: <Wholesaler_Stores_Connected />, label: "Stores Connected" },
  
  // Certification & Labels
  { path: "/Wholesaler_Labels", element: <Wholesaler_Labels />, label: "Wholesaler Labels" },
  { path: "/Wholesaler_Certificates", element: <Wholesaler_Certificates />, label: "Wholesaler Certificates" },
  
  // Analytics & Reports
  { path: "/Generate_Reports", element: <Generate_Reports />, label: "Generate Reports" },
  { path: "/Analytics_Wholesaler_Activity", element: <Analytics_Wholesaler_Activity />, label: "Analytics Activity" },
  { path: "/Reporting_Analytics", element: <Reporting_Analytics />, label: "Reporting & Analytics" },
  
  // Expense Management
  { path: "/MyExpense", element: <MyExpense />, label: "My Expense" },
  
  // Profile
  { path: "/Profile_Informations", element: <Profile_Informations />, label: "Profile Information" },
];

export const ROUTES_USER = [
  // Dashboard
  { path: "/customer-dashboard", element: <CustomerDashboard />, label: "Dashboard" },
  
  // Product Exploration
  { path: "/ViewProductsPage", element: <ViewProductsPage />, label: "View Products" },
  { path: "/Product_History", element: <Product_History />, label: "Product History" },
  { path: "/Certification_Feed", element: <Certification_Feed />, label: "Certification Feed" },
  
  // Store Exploration
  { path: "/ViewStoresPage", element: <ViewStoresPage />, label: "View Stores" },
  { path: "/Find_Stores", element: <Find_Stores />, label: "Find Stores" },
  
  // Profile
  { path: "/Profile_Informations", element: <Profile_Informations />, label: "Profile Information" },
];

export const ROUTES_STORE = [
  // Dashboard
  { path: "/StoreDashboard", element: <StoreDashboard />, label: "Dashboard" },
  
  // Store Management
  { path: "/Manage_my_store", element: <Manage_my_store />, label: "Manage My Store" },
  { path: "/Modify_store", element: <Modify_store />, label: "Modify Store" },
];

export const ROUTES_PUBLIC = [
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "/about", element: <AboutUs /> },
      { path: "/contact", element: <Contact /> },
      { path: "/partners/factories", element: <Factories /> },
      { path: "/partners/wholesalers", element: <Wholesalers /> },
      { path: "/partners/stores", element: <Stores /> },
      { path: "/blog", element: <Blog_List /> },
      { path: "/blog/:slug", element: <Blog_Details /> },
      { path: "/thank-you", element: <Thankyou /> },
    ],
    label: "Home"
  },
  { path: "/login", element: <Login />, label: "Login" },
  { path: "/signup", element: <Signup />, label: "Sign Up" },
  { path: "/recover-password", element: <PasswordRecovery />, label: "Recover Password" },
  { path: "*", element: <NotFound />, label: "Not Found" },
];

export const ROUTES_AUTH = [
  {
    element: <AuthLayout />, 
    children: [
      { path: "/login", element: <Login />, label: "Login" },
      { path: "/signup", element: <Signup />, label: "Sign Up" },
      { path: "/recover-password", element: <PasswordRecovery />, label: "Recover Password" },
    ],
  },
];